import { useMemo, useState } from 'react';
import { isAllowed } from '../../../Services/acl.service';
import apiClient from '../../../Services/ApiClient';
import useApiClient from '../../Base/Hooks/useApiClient';
import useRestApiClient from '../../Base/Hooks/useRestApiClient';
import { useAppContext } from '../../../Services/AppContext';
import useRootWorkplaceMeta from '../../Manager/Hooks/useRootWorkplaceMeta';

export default function useStripe() {
	const { isSplitPaymentSupported } = useAppContext();
	const [isLoading, setIsLoading] = useState(false);
	const { displayError } = useApiClient();
	const { showUnexpectedError } = useRestApiClient();
	const { meta, isLoading: isLoadingRootWorkplaceMeta } =
		useRootWorkplaceMeta();

	const isStripeConnectConfigured: boolean = useMemo(() => {
		return (
			meta?.find(item => item.key === 'stripeConnectConfigured')?.value ?? false
		);
	}, [meta]);

	const canSetupStripe = isAllowed('stripe_setup');

	const isStripeSetupRequested =
		isSplitPaymentSupported && !isStripeConnectConfigured;

	const handleStripeRegistration = async () => {
		setIsLoading(true);
		try {
			const response = await apiClient.get('/payments/stripe/account');
			if (response.status === 200) {
				if (response.data.redirectUrl) {
					// @ts-ignore
					window.location.href = response.data.redirectUrl;
				}
			} else {
				showUnexpectedError();
			}
		} catch (e) {
			displayError(e);
		}
		setTimeout(() => {
			setIsLoading(false);
		}, 1000);
	};

	return {
		isSplitPaymentSupported,
		isStripeSetupRequested,
		isStripeConnectConfigured,
		canSetupStripe,
		handleStripeRegistration,
		isLoading: isLoading || isLoadingRootWorkplaceMeta,
	};
}
